module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_vm._v("PROLOGUE")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-1"
    }
  }, [_vm._v("Translation")]), _vm._v(" "), _c('p', {
    staticClass: "verses1"
  }, [_c('sup', [_vm._v("1")]), _vm._v("Many great teachings have been given to us through the Law and the Prophets and the others that followed them, and for these we should praise Israel for instruction and wisdom. "), _c('sup', [_vm._v("2")]), _vm._v("Now, those who read the scriptures must not only themselves understand them, but must also as lovers of learning be able through the spoken and written word to help the outsiders. "), _c('sup', [_vm._v("3")]), _vm._v("So my grandfather Jesus, who had devoted himself especially to the reading of the Law and the Prophets and the other books of our ancestors, and had acquired considerable proficiency in them, was himself also led to write something pertaining to instruction and wisdom, "), _c('sup', [_vm._v("4")]), _vm._v("so that by becoming familiar also with his book those who love learning might make even greater progress in living according to the law.")]), _vm._v(" "), _c('p', {
    staticClass: "verses"
  }, [_c('sup', [_vm._v("5")]), _vm._v("You are invited therefore to read it with goodwill and attention, and to be indulgent in cases where, despite our diligent labor in translating, we may seem to have rendered some phrases imperfectly. "), _c('sup', [_vm._v("6")]), _vm._v("For what was originally expressed in Hebrew does not have exactly the same sense when translated into another language. "), _c('sup', [_vm._v("7")]), _vm._v("Not only this book, but even the Law itself, the Prophecies, and the rest of the books differ not a little when read in the original.")]), _vm._v(" "), _c('p', {
    staticClass: "verses"
  }, [_c('sup', [_vm._v("8")]), _vm._v("When I came to Egypt in the thirty-eighth year of the reign of Euergetes and stayed for some time, I found opportunity for no little instruction. "), _c('sup', [_vm._v("9")]), _vm._v("It seemed highly necessary that I should myself devote some diligence and labor to the translation of this book. "), _c('sup', [_vm._v("10")]), _vm._v("During that time I have applied my skill day and night to complete and publish the book for those living abroad who wished to gain learning and are disposed to live according to the law.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec3",
    attrs: {
      "id": "sec3-2"
    }
  }, [_vm._v("Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Introducing a book with a formal prologue was a practice that Jewish authors writing in Greek (e.g., 2 Macc 2:19–32) adopted from Greek literature (e.g., Polybius, "), _c('em', [_vm._v("Hist")]), _vm._v(". 1.1)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1898",
      "id": "footnote-1898-backlink"
    }
  }, [_vm._v("1")])]), _vm._v(" In this case, the prologue was composed not by the book’s author but by the book’s translator and grandson, who remains anonymous. The prologue is divided into three parts, the first being about the book (vv. 1–4), the second about its translation (vv. 5–7), and the third about its translator (vv. 8–10). Throughout, it is apparent that the translator wants to present Ben Sira as an authority figure, the manner in which he acknowledges his grandfather’s work according with the importance assigned to family (e.g., 3:1–2) and intergenerational chains of transmission (e.g., 8:9) in the book itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The grandson begins by situating the book in relation to a set of authoritative “teachings” (cf. 24:33) identified as “the Law and the Prophets and the others that followed them” (v. 1), “the Law and the Prophets and the other books of our ancestors” (v. 3), and “the Law … the Prophecies, and the rest of the books” (v. 7). Together these identifications constitute our earliest attestation of the tripartite division that came to characterize the Hebrew Bible—namely, the Law, the Prophets, and the Writings (cf. 38:34–39:3)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1897",
      "id": "footnote-1897-backlink"
    }
  }, [_vm._v("2")])]), _vm._v(" The second of these identifications (v. 3) is significant both in that it explicitly describes the corpus as a collection of books (cf. 24:23),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1896",
      "id": "footnote-1896-backlink"
    }
  }, [_vm._v("3")])]), _vm._v(" and in that these books are identified as a legacy—specifically, a legacy of “Israel” (v. 1)—that the translator shares with his audience (“our ancestors”)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1895",
      "id": "footnote-1895-backlink"
    }
  }, [_vm._v("4")])]), _vm._v(" For the Law and the Prophets, see 2 Macc 15:9; 4 Macc 18:10; Matt 5:17; 7:12; 22:40; John 1:45; Acts 13:15; 24:14; 28:23; Rom 3:21."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1894",
      "id": "footnote-1894-backlink"
    }
  }, [_vm._v("5")])]), _vm._v(" The more generic language used to designate the third group, meanwhile, suggests that the process of determining its contents was still under negotiation."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1893",
      "id": "footnote-1893-backlink"
    }
  }, [_vm._v("6")])]), _vm._v(" At any rate, these writings are referred to as “scriptures” (v. 2) to which the grandfather had devoted himself and in which he had acquired proficiency (v. 3)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1892",
      "id": "footnote-1892-backlink"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As the translator makes plain, however, his grandfather achieved this proficiency not in isolation but rather as one of those who “read the scriptures” (v. 2), a likely reference to the class of professional scribes in Israel at the time (cf. 1 Esd 8:8–9, 19; 9:39, 42, 49)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1891",
      "id": "footnote-1891-backlink"
    }
  }, [_vm._v("8")])]), _vm._v(" As one of these “lovers of learning” (cf. 8:8–9; 39:8), he is expected not only to understand the scriptures himself (v. 2) but also to furnish others who “love learning” (v. 4) with “instruction and wisdom” (vv. 1, 3) through both “the spoken and written word” (v. 2)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1890",
      "id": "footnote-1890-backlink"
    }
  }, [_vm._v("9")])]), _vm._v(" The readers, then, are being alerted to both the scriptural nature of the book (which draws extensively on biblical writings for its language and ideas) and the instructional nature of the book, the latter being determined especially by its participation in biblical wisdom traditions, represented in no small part by the book of Proverbs, from which the translator may have derived some of his language."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1889",
      "id": "footnote-1889-backlink"
    }
  }, [_vm._v("10")])]), _vm._v(" To the extent that it is also found in the work’s colophon, this language effectively creates a verbal and thematic frame around the entire book (cf. 50:27: “instruction in understanding and knowledge I have written in this book,” etc.).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Solidifying the prologue’s connection to the colophon is the identification of the book’s author as “Jesus” (v. 3)—the Greek form of the Hebrew name Joshua—an abbreviated version of the name provided by the author himself in 50:27 (“Jesus son of Eleazar son of Sirach of Jerusalem, whose mind poured forth wisdom”). As a teacher of wisdom, Ben Sira would have been expected to offer practical instruction on a range of topics relating to moral conduct, topics for which the “scriptures” are understood to be both foundational and generative. In this regard, it is noteworthy that within the ten verses of the prologue, the Law or law is mentioned no less than five times (vv. 1, 3, 4, 7, 10). Within this ambit, the legal legacy of Judaism is understood not only as a set of texts (“the Law”) students are expected to know but also as a set of norms (“the law”) students are expected to observe, the phrase “live/living according to the law” occurring at the end of both the first (v. 4) and last (v. 10) parts of the prologue. In writing “his book” (v. 4), then, Ben Sira joins a tradition that effectively seeks to join the Law or law and wisdom (cf. 15:1; 19:20)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1888",
      "id": "footnote-1888-backlink"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The scribal ethos coloring the prologue’s first part extends into the second part (vv. 5–7), where the audience is explicitly invited to read the book (v. 5), specifically, with a combination of goodwill and attention, the section effectively functioning as a disclaimer for the book’s translation, in which case it can be viewed together with the colophon to the Greek translation of the book of Esther: “In the fourth year of the reign of Ptolemy and Cleopatra, Dositheus … and his son Ptolemy brought to Egypt the preceding Letter about Purim, which they said was authentic and had been translated by Lysimachus son of Ptolemy, one of the residents of Jerusalem” (Add Esth 11:1).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In contrast to this statement, where the accuracy of the translation is taken for granted, in his prologue, the grandson readily acknowledges the challenges of translation work, warning the audience that his version may misrepresent the original sense of the Hebrew text (v. 5). As he goes on to argue, however, such deficiencies are attributable not to any particular lack of skill on his part but rather to the inherent difficulties that attend rendering “what was originally expressed in Hebrew” into another language (v. 6),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1887",
      "id": "footnote-1887-backlink"
    }
  }, [_vm._v("12")])]), _vm._v(" an observation that applies to the scriptures themselves, which “differ not a little when read in the original” (v. 7).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Whereas the first part of the prologue situated Ben Sira’s book in relation to the scriptures in their original language, then, the second situates it in relation to their version(s) in translation, which is understood as an extension of the authoritative tradition, albeit one that is unavoidably subject to corruption. In this regard, it is interesting that the position advanced by the grandson here more nearly approximates opinions circulating in rabbinic Judaism than opinions found in the Greek-speaking diaspora, a distinction that becomes clear when we compare b. Qidd. 49a (“Whoever translates literally is a liar, and whoever translates liberally is guilty of blasphemy”) with Let. Aris. 310 (“Since this version [of the Law] has been made rightly and reverently, and in every respect accurately, it is good that it should remain exactly so, and that there should be no revision”). Similar issues also emerge when we compare the quality of the Greek used in the prologue—which is relatively polished—with that used in the book itself, the latter representing what Wright describes as a “more or less stilted translationese” akin to that used in the Septuagint."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1886",
      "id": "footnote-1886-backlink"
    }
  }, [_vm._v("13")])]), _vm._v(" One function of the prologue, then, is to show the reader that while the translator was indeed capable of writing in a more elevated style, he chose instead to employ forms of language that would better situate his grandfather’s book in a biblical context.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the first part of the prologue, the task of the scribal profession was said to entail providing instruction for “the outsiders” (v. 2), a likely reference to Jews living outside Judea, a point of some relevance as we move to the third part of the prologue (vv. 8–10),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1885",
      "id": "footnote-1885-backlink"
    }
  }, [_vm._v("14")])]), _vm._v(" which states that the book was published “for those living abroad” (v. 10)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1884",
      "id": "footnote-1884-backlink"
    }
  }, [_vm._v("15")])]), _vm._v(" The grandson also states that he emigrated (presumably from Judea) to Egypt in the thirty-eighth year of the reign of “Euergetes” (v. 8), that is, King Ptolemy VII Physkon Euergetes II (170–164, 145–117 BCE). The year of his arrival, then, would be 132 BCE, after which he “stayed for some time” (v. 8). While he does not state so explicitly, the reference to finding “opportunity” for instruction (cf. 38:24) suggests that he went there for study, in which case the grandson aligns himself with the grandfather not only in terms of lineage but also in terms of profession."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1883",
      "id": "footnote-1883-backlink"
    }
  }, [_vm._v("16")])]), _vm._v(" Exactly when he completed the work of translation is difficult to say, though some scholars interpret the wording of verse 8 to mean that he published the book sometime after the king’s death in 117 BCE."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1882",
      "id": "footnote-1882-backlink"
    }
  }, [_vm._v("17")])]), _vm._v(" The “you” of verse 5, then, are Jews living in Egypt, of which the translator is apparently still one. Why he deemed it “highly necessary” to dedicate significant labor to the creation of the translation is unclear (cf. 24:34), though commentators sometimes speculate that the grandson was endeavoring to address perceived lapses in the comportment of Jews living in the diaspora."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#footnote-1881",
      "id": "footnote-1881-backlink"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1898-backlink",
      "id": "footnote-1898"
    }
  }, [_vm._v("1")]), _vm._v(". For a prologue introducing the translation of a gnomic text (i.e., the "), _c('em', [_vm._v("Sentences")]), _vm._v(" of Sextus), see Wilson, "), _c('em', [_vm._v("Ancient Wisdom")]), _vm._v(", 8–9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1897-backlink",
      "id": "footnote-1897"
    }
  }, [_vm._v("2")]), _vm._v(". In "), _c('em', [_vm._v("C")]), _vm._v(". "), _c('em', [_vm._v("Ap")]), _vm._v(". 1.37–41, Josephus mentions “the five books of Moses,” “the prophets” (thirteen books), and “the remaining four books” (probably Psalms, Song of Songs, Proverbs, and Ecclesiastes). Cf. 2 Esd 14:45.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1896-backlink",
      "id": "footnote-1896"
    }
  }, [_vm._v("3")]), _vm._v(". The Hebrew Bible itself sometimes refers to its contents as “books” (e.g., Deut 28:58; Josh 8:34; 24:26; Jer 25:13; Nah 1:1). Cf. Josephus, "), _c('em', [_vm._v("C")]), _vm._v(". "), _c('em', [_vm._v("Ap")]), _vm._v(". 2.45 (“the books of our sacred scriptures”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1895-backlink",
      "id": "footnote-1895"
    }
  }, [_vm._v("4")]), _vm._v(". For “praise Israel” (v. 1), see 44:1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1894-backlink",
      "id": "footnote-1894"
    }
  }, [_vm._v("5")]), _vm._v(". Cf. Luke 24:44 (“the law of Moses, the prophets, and the psalms”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1893-backlink",
      "id": "footnote-1893"
    }
  }, [_vm._v("6")]), _vm._v(". Alternatively, what the grandson describes is not a tripartite canon but rather three categories of Jewish literature more generally. See Armin Lange, “The Law, the Prophets, and the Other Books,” in "), _c('em', [_vm._v("Studies in the Book of Ben Sira")]), _vm._v(", ed. Géza G. Xeravits, JSJSup 127 (Leiden: Brill, 2008), 55–80. For the idea that the grandson is protesting against an exclusive focus on the Law and the Prophets, see David M. Carr, "), _c('em', [_vm._v("Holy Resilience: The Bible’s Traumatic Origins")]), _vm._v(" (New Haven: Yale University Press, 2014), 150–51.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1892-backlink",
      "id": "footnote-1892"
    }
  }, [_vm._v("7")]), _vm._v(". For the “scriptures” (v. 2), see McDonald, "), _c('em', [_vm._v("Biblical Canon")]), _vm._v(", 20–37.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1891-backlink",
      "id": "footnote-1891"
    }
  }, [_vm._v("8")]), _vm._v(". Horsley, "), _c('em', [_vm._v("Scribes")]), _vm._v(", 71–87.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1890-backlink",
      "id": "footnote-1890"
    }
  }, [_vm._v("9")]), _vm._v(". Instruction is something that is heard (e.g., 6:33–35) as well as read (e.g., 39:32).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1889-backlink",
      "id": "footnote-1889"
    }
  }, [_vm._v("10")]), _vm._v(". E.g., Prov 1:2 (“For learning about wisdom and instruction, for understanding words of insight”), 5, 7; 15:33; 19:20; 23:23.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1888-backlink",
      "id": "footnote-1888"
    }
  }, [_vm._v("11")]), _vm._v(". Cf. Deut 4:5–6; Schnabel, "), _c('em', [_vm._v("Law and Wisdom")]), _vm._v(", 78–79.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1887-backlink",
      "id": "footnote-1887"
    }
  }, [_vm._v("12")]), _vm._v(". Cf. 2 Macc 15:38 (“If [my story] is well told and to the point, that is what I myself desired; if it is poorly done and mediocre, that was the best I could do”).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1886-backlink",
      "id": "footnote-1886"
    }
  }, [_vm._v("13")]), _vm._v(". Benjamin G. Wright, “Why a Prologue? Ben Sira’s Grandson and His Greek Translation,” in "), _c('em', [_vm._v("Emanuel: Studies in Hebrew Bible, Septuagint, and Dead Sea Scrolls")]), _vm._v(", ed. Shalom M. Paul, VTSup 94 (Leiden: Brill, 2003), 633–44.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1885-backlink",
      "id": "footnote-1885"
    }
  }, [_vm._v("14")]), _vm._v(". In its use of first person singular speech forms, the third part anticipates autobiographical sections of the book such as 33:16–19; 34:12–13; 51:13–30.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1884-backlink",
      "id": "footnote-1884"
    }
  }, [_vm._v("15")]), _vm._v(". For the Jewish population in Egypt at this time, see David Noy, “Egypt,” in "), _c('em', [_vm._v("The Eerdmans Dictionary of Early Judaism")]), _vm._v(", ed. John J. Collins and Daniel C. Harlow (Grand Rapids: Eerdmans, 2010), 563–68.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1883-backlink",
      "id": "footnote-1883"
    }
  }, [_vm._v("16")]), _vm._v(". Translation was one of the scribal tasks, e.g., Sum. Prov. Coll. 2.49 (“If the scribe does not know Sumerian, how will the translator succeed?”)")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1882-backlink",
      "id": "footnote-1882"
    }
  }, [_vm._v("17")]), _vm._v(". Skehan and DiLella, "), _c('em', [_vm._v("Wisdom of Ben Sira")]), _vm._v(", 134.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-1881-backlink",
      "id": "footnote-1881"
    }
  }, [_vm._v("18")]), _vm._v(". E.g., John G. Snaith, "), _c('em', [_vm._v("Ecclesiasticus or the Wisdom of Jesus Son of Sirach")]), _vm._v(" (Cambridge: Cambridge University Press, 1974), 7–8.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2cbd738","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Prologue.vue
// module id = 78
// module chunks = 0